import React from 'react'
import { Flex } from '@/components/core'
import { classNameBuilder } from '@/helpers'

export type StepStateType = 'disabled' | 'current' | 'done'
export interface StepProps {
  text: string
  icon: React.ReactNode
  state?: StepStateType
}
const Step: React.FC<StepProps> = ({ text, icon, state = 'disabled' }) => {
  return (
    <Flex className="flex-col items-center gap-x-4 gap-y-2 max-md:w-[60px] md:flex-row">
      <Flex
        className={classNameBuilder(
          'h-6 w-6 shrink-0 grow-0 items-center justify-center rounded-full md:h-10 md:w-10',
          transitionClasses,
          stateClassMap[state]
        )}
      >
        {icon}
      </Flex>
      <span
        className={classNameBuilder(
          'text-xxs font-bold uppercase text-electric-indigo-50 md:text-xs',
          transitionClasses,
          state === 'current' ? '' : 'text-opacity-50'
        )}
      >
        {text}
      </span>
    </Flex>
  )
}

export default Step

const stateClassMap: Record<StepStateType, string> = {
  current: 'bg-electric-indigo-50 text-electric-indigo-900',
  done: 'bg-electric-indigo-50 text-electric-indigo-900 opacity-50',
  disabled:
    'border border-electric-indigo-50/20 text-electric-indigo-50 text-opacity-50'
}

const transitionClasses = 'transition duration-300'
